import { AdSDKHelper } from '../ads/AdSDKHelper';
import { GameMonetizeAdSDK } from '../ads/GameMonetizeAdSDK';
import { Assets } from '../Assets';
import { WebfontFile } from '../loaders/WebfontFile';
import { SaveLoadManager } from '../saveload/SaveLoadManager';
import { SceneKeys } from '../SceneKeys';
import { BaseScene } from './BaseScene';

export class BootScene extends BaseScene {

    constructor() {
        super("BootScene");
    }

    preload() {
        if (this.game.config.gameTitle === "Game") {
            setTimeout(() => {
                const style = 'background-color: #c51244; color: white; border: 2px solid black; font-size: 1.2em;box-shadow: 1px 1px 1px #aaaaaa;padding: 10px;margin-bottom:5px';
                console.log("%cChange the game title in config.js, otherwise SaveLoadManager will not work.", style);
            }, 1000);
        } else {
            SaveLoadManager.init(this, this.game.config.gameTitle);
        }

        AdSDKHelper.current = new GameMonetizeAdSDK();
AdSDKHelper.current.init();

        //Load preloader assets here..
        this.load.addFile(new WebfontFile(this.load, "google", ["Poppins"]));
    }

    loadAtlas(asset: { key: string, imageUrl: string, jsonUrl: string }) {
        this.load.atlas(asset.key, asset.imageUrl, asset.jsonUrl);
    }

    async create() {

        const c = await import('./Preloader');
        this.scene.add(SceneKeys.PRELOADER, c.PreloaderScene, false);
        this.scene.start(SceneKeys.PRELOADER);
    }

}